export function previewRows(cards) {
  return cards.flatMap(card => card.matched_variants?.length ? card.matched_variants.map(variant => ({ ...card, variant, selection_key: `${card.id}:${variant}` })) : [{ ...card, selection_key: card.id }]);
}

export function selectionPayload(rows, keys) {
  const selected = rows.filter(card => keys.includes(card.selection_key));
  const finish_overrides = {};
  for (const card of selected) if (card.variant) finish_overrides[card.id] = [...new Set([...(finish_overrides[card.id] || []), card.variant])];
  return { card_ids: [...new Set(selected.map(card => card.id))], finish_overrides };
}
